import React from "react";
import styles from "../../utils/gridStyles.js";
import setHeaderRender from "../../../components/app/setHeaderRender";
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';
const NERTHUS = process.env.REACT_APP_NERTHUS_API_URL + '/images';
import dateFormat from 'dateformat';

const setColumns = ({ modalDetail, allowWrite, changeDelay, setLoading, updateSelectMultiRows, selectUnselectAllRows }) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
            cellRenderer: ({ value, data, onChange, disabled }) => (<input type="checkbox" onChange={onChange} checked={value} disabled={disabled}
                onClick={() => { updateSelectMultiRows(data.code); }} />),
            headerCellRenderer: ({ checked, disabled, onChange }) => (<input type="checkbox" onChange={onChange} checked={checked} disabled={disabled}
                onClick={selectUnselectAllRows} />)
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({ tableManager, column }) => (setHeaderRender({ 'nameHeader': 'code', changeDelay, tableManager, column }))
        },
        {
            id: "2",
            field: "name",
            label: "Name",
            sortable: false,
            resizable: true,
            headerCellRenderer: ({ tableManager, column }) => (setHeaderRender({ 'nameHeader': 'Name', changeDelay, tableManager, column }))
        },
        {
            id: "3",
            field: "url",
            label: "Url",
            width: '300px',
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (setHeaderRender({ 'nameHeader': 'Url', changeDelay, tableManager, column }))
        },
        {
            id: "4",
            label: 'Type',
            field: "type",
            width: "150px",
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (<>
                <table><tbody>
                    <tr><td>Type</td></tr>
                    <tr>
                        <td>
                            <Form.Select
                                size="sm"
                                style={{ paddingTop: 0, paddingBottom: 0 }}
                                onChange={(e) => {
                                    changeDelay(e.target.value, tableManager, column);
                                    setLoading(true);
                                }}
                            ><option value="">All</option>
                                {['External', 'Internal'].map((label) => (
                                    <option key={label} value={label}>{label}</option>
                                ))}
                            </Form.Select>
                        </td>
                    </tr>
                </tbody></table> </>),
        },
        {
            id: "5",
            label: 'priorityLevel',
            field: "priorityLevel",
            width: "150px",
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (<>
                <table><tbody>
                    <tr><td>priorityLevel</td></tr>
                    <tr>
                        <td>
                            <Form.Select
                                size="sm"
                                style={{ paddingTop: 0, paddingBottom: 0 }}
                                onChange={(e) => {
                                    changeDelay(e.target.value, tableManager, column);
                                    setLoading(true);
                                }}
                            ><option value="">All</option>
                                {['Media', 'Alta', 'Muy Alta'].map((label, index) => (
                                    <option key={index} value={index+1}>{label}</option>
                                ))}
                            </Form.Select>
                        </td>
                    </tr>
                </tbody></table> </>),
            cellRenderer: ({
                data,
            }) => {
                const priorityLabels = ['Baja', 'Media', 'Alta', 'Muy Alta'];
                return priorityLabels[data.priorityLevel] || 'Desconocido';
            },
        },
        {
            id: "8",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy", true)),
        },
        {
            id: "buttons",
            label: "Action",
            width: '110px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                    {allowWrite
                        ? (<> <button
                            title="Edit"
                            style={styles.styleButton.editButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                modalDetail(data.code, "Edit");
                            }}
                        >
                            {styles.EDIT_SVG}
                        </button> {" - "}
                            <button
                                title="Delete"
                                style={styles.styleButton.editButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    modalDetail(data.code, "Delete");
                                }}
                            >
                                {styles.CANCEL_SVG}
                            </button>
                        </>)
                        : ''
                    }
                </div>
            )
        }
    ];
};

export default setColumns;
